import {
  isValidPhoneNumber,
  parsePhoneNumberFromString,
  type CountryCode,
} from 'libphonenumber-js'

import { DEFAULT_PHONE_COUNTRY, MAX_PHONE_LENGTH } from './consts'

type PhoneNumberValue = string | number | null | undefined

type PhoneNumberFormatOptions = {
  country?: CountryCode
  format?: 'international' | 'national'
}

const getPhoneString = (value: PhoneNumberValue) => String(value ?? '').trim()

const getPhoneDigits = (value: string) => value.replace(/\D/g, '')

export const formatPhoneInput = (value: PhoneNumberValue) =>
  getPhoneDigits(String(value ?? '')).slice(0, MAX_PHONE_LENGTH)

export const formatPhoneDisplay = (
  value: PhoneNumberValue,
  { country = DEFAULT_PHONE_COUNTRY, format = 'international' }: PhoneNumberFormatOptions = {},
) => {
  const phone = getPhoneString(value)

  if (!phone) {
    return ''
  }

  const parsedPhone = parsePhoneNumberFromString(phone, country)

  if (!parsedPhone) {
    return phone
  }

  return format === 'national' ? parsedPhone.formatNational() : parsedPhone.formatInternational()
}

export const formatPhoneSubmit = (value: PhoneNumberValue, country = DEFAULT_PHONE_COUNTRY) => {
  const phone = getPhoneString(value)

  if (!phone) {
    return ''
  }

  const parsedPhone = parsePhoneNumberFromString(phone, country)

  return parsedPhone?.number.replace('+', '') ?? phone.replace(/\D/g, '')
}

export const isValidPhone = (value: PhoneNumberValue, country = DEFAULT_PHONE_COUNTRY) => {
  const phone = getPhoneString(value)

  return phone === '' || isValidPhoneNumber(phone, country)
}
